import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dataStorico'
})

export class DataStoricoPipe implements PipeTransform {
  transform(value: string | Date | null | undefined): string {
    if (typeof value === 'undefined' || value === null) return '';

    if (typeof value === 'string') {
      value = new Date(value);
    }

    if (!(value instanceof Date) || value.toString() === 'Invalid Date' || value.getFullYear() <= 1970) {
      return '';
    }

    let result = value.toLocaleDateString('it-IT', { year: 'numeric', month: '2-digit', day: '2-digit' });
    if (value.toLocaleTimeString() !== '00:00:00') {
      result += ' alle ' + value.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
    }

    return result;
  }
}
